<template>
    <Paper class="barcode-merge">
        <m-table
            v-show="!isDetailShow"
            ref="RegistrationTable"
            :pageTotal="pageTotal"
            :tableData="listData"
            :config="tableConfig"
            @rowDBclick="goDetail"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @search="getData"
            @onSearchDataChange="onSearchDataChange">
        </m-table>
        <detail
            v-if="isDetailShow"
            :data="activeRow"
            :columns="tableConfig.table.columns"
            @backToList="back" />
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import detail from './detail';
import { barcodeTobSearch } from '@/modules/sn/api/lcbsManagement.js';
import { tableConfig } from './tableConfig.js';
import { cloneDeep } from 'lodash';
import { searchByDictCodes } from '@/modules/sn/api/systemManagementApi.js';
import { mapGetters } from 'vuex';
export default {
    name: 'barcodeArchive',
    components: { Paper, mTable, detail },
    data() {
        return {
            pageTotal: 0, // 总条数
            listData: [], // 列表数据
            searchData: {}, // 搜索框数据
            tableConfig: tableConfig, // 表格配置
            isDetailShow: false,
            activeRow: {},
            dictObj: {}
        };
    },
    mounted() {
        this.isDetailShow = false;
        this.handleDicts();
    },
    computed: {
        ...mapGetters(['currentTenant'])
    },
    methods: {
        onSearchDataChange(data) {
            this.searchData = data;
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            this.getData(this.searchData);
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = pageSize;
            this.getData(this.searchData);
        },
        // 查询
        getData(data) {
            const params = {
                param: cloneDeep(data),
                tenantCode: this.currentTenant.tenantCode
            };
            params.param.pageSize = this.tableConfig.page.pageSize;
            params.param.pageNo = this.tableConfig.page.pageNo;
            if (!params.param.barcodeNo) {
                return this.$message.warning('请输入条码');
            }
            // params.tenantCode = this.currentTenant.tenantCode;
            // params.pageSize = this.tableConfig.page.pageSize;
            // params.pageNo = this.tableConfig.page.pageNo;
            // this.listExportParams = params;
            this.listData = [];
            barcodeTobSearch(params).then((res) => {
                if (res.code + '' === '0' && res.data) {
                    this.setData(res.data);
                }
            });
        },
        setData(data) {
            const list = data.list || [];
            this.pageTotal = data.totalCount;
            this.listData = list.map((item) => {
                item.orgType = this.dictObj.SN_LBCS_SHIP_ORG_TYPE[item.orgType];
                item.state = item.state ? this.stateDictList[item.state] : '';
                item.shipStatus = item.shipStatus
                    ? this.shipStatusDictList[item.shipStatus]
                    : '';
                item.id = item.id + '';
                return item;
            });
        },
        goDetail(row, column, event) {
            this.isDetailShow = true;
            this.activeRow = row;
        },
        back() {
            this.activeRow = {};
            this.isDetailShow = false;
        },
        handleDicts() {
            const params = {
                dictCodes: 'SN_LBCS_SHIP_ORG_TYPE'
            };
            searchByDictCodes(params).then((res) => {
                if (res && res.data) {
                    Object.keys(res.data).forEach((key) => {
                        const obj = {};
                        res.data[key].forEach((item) => {
                            obj[item.code] = item.name;
                        });
                        this.dictObj[key] = obj;
                    });
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.barcode-merge {
    /deep/ .el-table {
        height: calc(100vh - 200px) !important;
    }
}
</style>
